import HttpService from "@core/services/http/http.service";
import {
  Category,
  CategoryV2,
  CreateCategory,
  GetAllResponse,
  GetListResponse,
} from "@app/types";
import { RequestParams, Signal } from "@core/services/http/http.type";

class _CategoryService {
  public getAll() {
    return HttpService.get<GetAllResponse<Category>>(
      "/user/api/v1/categories/all"
    );
  }

  public getAllV2(signal?: Signal) {
    return HttpService.get<GetListResponse<CategoryV2>>(
      "/user/api/v2/categories/all",
      { signal }
    );
  }

  public getList(
    requestParams?: RequestParams,
    signal?: Signal,
    isShowLoading?: boolean
  ) {
    return HttpService.get<GetListResponse<Category>>(
      "/user/api/v1/categories",
      {
        queryParams: { ...requestParams },
        signal,
        isShowLoading,
      }
    );
  }

  public create(category: CreateCategory) {
    return HttpService.post("/user/api/v1/categories", {
      body: { ...category },
    });
  }

  public update(categoryId: number, category: CreateCategory) {
    return HttpService.patch(`/user/api/v1/categories/${categoryId}`, {
      body: { ...category },
    });
  }

  public delete(categoryId: number) {
    return HttpService.delete(`/user/api/v1/categories/${categoryId}`);
  }
}

const CategoryService = new _CategoryService();

export default CategoryService;
